import { render, staticRenderFns } from "./vue-vcard.vue?vue&type=template&id=6a639a1b&scoped=true&"
import script from "./vue-vcard.vue?vue&type=script&lang=js&"
export * from "./vue-vcard.vue?vue&type=script&lang=js&"
import style0 from "./vue-vcard.vue?vue&type=style&index=0&id=6a639a1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a639a1b",
  null
  
)

export default component.exports